<div 
    class="matatuAppWrapper" #matatuAppWrapper>
    <router-outlet></router-outlet>
</div>

